import { useEffect, useMemo } from "react";
import Footer from "../../../components/footer/footer";
import MaterialTable from "../../../components/material-table/material-table";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchPage } from "./redux/actionCreator";
import {
  pageViewChangeCurrentPage,
  setColumnOrder,
  setPageViewPages,
  setPageViewPaginationModel,
  setRowData,
} from "./redux/reducer";
import { IPaginationModel } from "../../../@types/pagination-model";
import NumberAggregation from "../../../components/material-table/components/number-aggregation";
import DefaultAggregation from "../../../components/material-table/components/default-aggregation";
// import HeaderCell from "../../../components/material-table/components/header-cell";
import { IPage } from "../../../@types/page";
import Button from "../../../components/button/button";
// import Filter from "../../../components/filter/filter";

const PageView = () => {
  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const dispatch = useAppDispatch();
  const { pages, currentPage, rows, columns, columnOrder, paginationModel } =
    useAppSelector((store) => store?.pages);
  const { pageNo, limit } = paginationModel;

  useEffect(() => {
    dispatch(fetchPage(1));
  }, [dispatch]);

  const handleChangePage = (page: number) =>
    dispatch(pageViewChangeCurrentPage(page));

  const handleSetPages = (updatedPages: IPage[]) =>
    dispatch(setPageViewPages(updatedPages));

  useEffect(() => {
    dispatch(fetchPage(currentPage));
  }, [dispatch, currentPage]);

  const tableRows = useMemo(() => {
    const start = limit * (pageNo - 1);
    return rows.slice(start, start + limit);
  }, [rows, pageNo, limit]);

  const tableColumns = useMemo(() => {
    return columns?.map((col: any) => {
      let updatedCol = {
        ...col,
        // Header: ({ column }: any) => <HeaderCell column={column} />,
        enableSorting: true,
      };

      if (col?.type === "number") {
        updatedCol = {
          ...updatedCol,
          muiEditTextFieldProps: {
            type: "number",
          },
          Footer: ({ column }: any) => {
            return <NumberAggregation data={tableRows} column={column?.id} />;
          },
        };
      } else if (col.type === "string") {
        updatedCol = {
          ...updatedCol,
          Footer: ({ column }: any) => (
            <DefaultAggregation data={tableRows} column={column.id} />
          ),
        };
      }

      return updatedCol;
    });
  }, [tableRows, columns]);

  const handlePaginationModel = (model: IPaginationModel) => {
    dispatch(setPageViewPaginationModel(model));
  };

  const total = limit ? Math.ceil(rows.length / limit) : 0;

  const handleColumnOrdering = (colOrder: string[]) => {
    dispatch(setColumnOrder(colOrder.slice(1)));
  };

  const updateData = (value: string, column: any, rowId: string) => {
    const payload = {
      value: column?.columnDef?.type === "number" ? Number(value) : value,
      columnId: column.id,
      rowId,
    };

    dispatch(setRowData(payload));
  };

  // const handleOpenFilter = (event: React.MouseEvent<HTMLButtonElement>) =>
  // setAnchorEl(event.currentTarget);

  // const handleCloseFilter = () => setAnchorEl(null);

  return (
    <>
      <Button>Open Filter</Button>
      <MaterialTable
        rows={tableRows}
        columns={tableColumns}
        paginationModel={paginationModel}
        totalPages={total}
        columnOrder={["mrt-row-select", ...columnOrder]}
        handleColumnOrdering={handleColumnOrdering}
        updateData={updateData}
      />
      <Footer
        pages={pages}
        setPages={handleSetPages}
        currentPage={currentPage}
        setCurrentPage={handleChangePage}
        total={total}
        paginationModel={paginationModel}
        handlePaginationModel={handlePaginationModel}
      />

      {/* {anchorEl && <Filter anchorEl={anchorEl} onClose={handleCloseFilter} />} */}
    </>
  );
};

export { PageView };
export default PageView;
